import React, { Component } from 'react';
import Styles from './index.less';

interface CellProps {
    className?: string;
    style?: React.CSSProperties;
    size?: React.CSSProperties;
    children?: React.ReactNode;
}

export default class Cell extends Component<CellProps> {
    public render() {
        return (
            <div
                // eslint-disable-next-line react/no-string-refs
                ref="domRef"
                className={Styles.cell}
                style={this.props.style}
            >
                {this.props.children}
            </div>
        );
    }
}
